import lzString from 'lz-string';

export default {
  data() {
    return {
      path: '',
    };
  },
  computed: {
    urlQuery() {
      return this.decompressUrlQuery(this.$route.params.urlQuery);
    },
  },
  methods: {
    getUrlQueryParam(param) {
      if (param === undefined) return this.urlQuery;
      return this.urlQuery[param];
    },
    compressUrlQuery(data) {
      return lzString.compressToEncodedURIComponent(JSON.stringify(data));
    },
    decompressUrlQuery(query) {
      if (query) {
        const decompressedString = lzString.decompressFromEncodedURIComponent(query);
        try {
          return JSON.parse(decompressedString);
        } catch (e) {
          console.log('Query string isn\'t a JSON string', decompressedString);
          return {};
        }
      }
      return {};
    },
    pushQuery(route, data, cb = () => {}) {
      const { commit } = this.$store;
      commit('saveUrlQuery', {
        name: route.name,
        data,
      });
      try {
        this.$router
          .replace({
            name: route.name,
            params: {
              ...route.params,
              urlQuery: this.compressUrlQuery(data),
            },
          })
          .then(() => {
            cb();
          })
          .catch((err) => {
            if (err.name === 'NavigationDuplicated') return;
            console.error(err);
          });
      } catch {}
    },
    extendUrlQuery(data) {
      const query = { ...this.urlQuery, ...data };
      return this.compressUrlQuery(query);
    },
  },
};
